import { render, staticRenderFns } from "./epidemicDatas.vue?vue&type=template&id=761f40c4&scoped=true&"
import script from "./epidemicDatas.vue?vue&type=script&lang=js&"
export * from "./epidemicDatas.vue?vue&type=script&lang=js&"
import style0 from "./epidemicDatas.vue?vue&type=style&index=0&id=761f40c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761f40c4",
  null
  
)

export default component.exports